import React, { useState, useEffect } from "react";

import QRCode from "react-qr-code";
import ShareIcon from "@material-ui/icons/Share";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PrintIcon from "@material-ui/icons/Print";

import { useDataProvider } from "react-admin";
import { ComponentToPrint } from "./QrcodePageTemplate1";
import { useReactToPrint } from "react-to-print";
import {
  PageContainer,
  ShareGrid,
  ShareCard,
  Title,
  Subtitle,
  LinkRow,
  LinkInput,
  ActionGroup,
  ActionButton,
  ActionIcon,
  ShareBadge,
  ShareHelper,
  HelperItem,
  HintText,
  InstructionList,
  QRCodeCard,
  QRCodeWrapper,
  QRTitle,
} from "./QrcodePage/styles.js";

const QrcodePage = (props) => {
  const componentRef = React.useRef();
  const [data, setData] = useState({ teste: "aaa" });
  const dataProvider = useDataProvider();
  const [copyLabel, setCopyLabel] = useState("Copiar link");
  const [shareStatus, setShareStatus] = useState("");

  const shareUrl = `${window.location.protocol}//${window.location.host}`;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopyLabel("Link copiado!");
      setTimeout(() => setCopyLabel("Copiar link"), 1800);
    } catch (error) {
      setCopyLabel("Não foi possível copiar");
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Menu Legal",
          text: "Acesse o menu Digital do meu estabelecimento",
          url: shareUrl,
        });
        setShareStatus("Link compartilhado!");
      } catch (error) {
        setShareStatus("Compartilhamento cancelado");
      }
    } else {
      setShareStatus("Compartilhamento não disponível neste navegador");
    }
    setTimeout(() => setShareStatus(""), 2200);
  };

  const getData = React.useCallback(() => {
    dataProvider
      .getOne("configuration", {})
      .then((res) => {
        if (res) setData(res.data);
      })
      .catch((error) => {
        //console.log(error);
      });
  }, [dataProvider, setData]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer>
      <ShareGrid>
        <ShareCard>
          <ShareBadge>Menu Legal</ShareBadge>
          <Title>Compartilhe seu Menu Legal</Title>
          <Subtitle>
            Deixe o cardápio oficial visível para clientes, compartilhando o
            link direto ou fixando o QR Code em pontos estratégicos.
          </Subtitle>
          <LinkRow>
            <LinkInput
              value={shareUrl}
              readOnly
              aria-label="URL do menu legal"
            />
          </LinkRow>
          <ActionGroup>
            <ActionButton bg="#2d4cff" onClick={handleShare}>
              <ActionIcon>
                <ShareIcon style={{ fontSize: 20 }} />
              </ActionIcon>
              Compartilhar
            </ActionButton>
            <ActionButton bg="#141414" onClick={handleCopy}>
              <ActionIcon>
                <FileCopyIcon style={{ fontSize: 20 }} />
              </ActionIcon>
              {copyLabel}
            </ActionButton>
            <ActionButton bg="#ed4e2a" onClick={handlePrint}>
              <ActionIcon>
                <PrintIcon style={{ fontSize: 20 }} />
              </ActionIcon>
              Imprimir modelo
            </ActionButton>
          </ActionGroup>
          {shareStatus && <HintText>{shareStatus}</HintText>}
          <ShareHelper>
            <HelperItem>
              Compartilhe o link em grupos de WhatsApp, Instagram e Facebook
              para multiplicar visualizações.
            </HelperItem>
            <HelperItem>
              Salve a URL no perfil oficial e fixe o QR Code no cardápio físico
              para acessos imediatos.
            </HelperItem>
            <HelperItem>
              Atualize o QR Code sempre que lançar promoções para rastrear os
              acessos.
            </HelperItem>
          </ShareHelper>
          <HintText>
            Abra a impressora e cole o QR Code no balcão para facilitar o
            atendimento.
          </HintText>
          <InstructionList>
            <li>Compartilhe o link em redes sociais, WhatsApp e Instagram.</li>
            <li>Encoste o QR Code na mesa para o cliente escanear rapidamente.</li>
            <li>Atualize o QR Code na vitrine sempre que fizer promoções.</li>
          </InstructionList>
        </ShareCard>

        <QRCodeCard>
          <QRTitle>QRCode oficial</QRTitle>
          <QRCodeWrapper>
            <QRCode
              value={`${shareUrl}?qrcode_origin=default`}
              size={180}
            />
          </QRCodeWrapper>
          <Subtitle>
            O QR Code já inclui o parâmetro necessário para rastrear os
            acessos que chegam pelo tablet ou mesa.
          </Subtitle>
        </QRCodeCard>
      </ShareGrid>

      <div style={{ display: "none" }}>
        <ComponentToPrint ref={componentRef} data={data} />
      </div>
    </PageContainer>
  );
};

export default QrcodePage;
